export const NOTIFICATION_WIDGETS_CLOSE = 'NOTIFICATION_WIDGETS_CLOSE';

export const closeNotificationWidget = key => ({
    type: NOTIFICATION_WIDGETS_CLOSE,
    key
});
